import { useState, useEffect } from 'react'
import BookingWidget from './components/BookingWidget'

function App() {
  const [seats, setSeats] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [availabilityFilter, setAvailabilityFilter] = useState(null)
  const [selectedSeat, setSelectedSeat] = useState(null)
  const [language, setLanguage] = useState('en')
  const [activeSection, setActiveSection] = useState('home')

  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api'

  // Translations object
  const translations = {
    en: {
      libraryName: 'Dhaka Library',
      subtitle: 'Book your perfect study spot in Nohar, Rajasthan',
      home: 'Home',
      aboutUs: 'About Us',
      aboutLibrary: 'About Library',
      missionVision: 'Mission & Vision',
      libraryStaff: 'Library Staff',
      services: 'Services',
      bookLending: 'Book Lending',
      readingRoom: 'Reading Room',
      digitalServices: 'Digital Services',
      photoGallery: 'Photo Gallery',
      eResources: 'E-Resources',
      sscExam: 'SSC Exam Previous Papers',
      rpscTeacher: 'RPSC Teacher Exam',
      digitalLibrary: 'Digital Library',
      eBooks: 'E-Books',
      researchSupport: 'Research Support',
      researchGuides: 'Research Guides',
      thesisRepository: 'Thesis Repository',
      citationHelp: 'Citation Help',
      loading: 'Loading available seats...',
      tryAgain: 'Try Again',
      studySeats: 'Study Seats',
      allSeats: 'All Seats',
      available: 'Available',
      occupied: 'Occupied',
      noSeats: 'No seats match the selected filter.',
      type: 'Type',
      floor: 'Floor',
      amenities: 'Amenities',
      bookNow: 'Book Now',
      bookSeat: 'Book Seat',
      timeSlotsPrice: 'Time Slots & Pricing',
      morningShift: 'Morning Shift',
      eveningShift: 'Evening Shift',
      fullDay: 'Full Day',
      save: 'Save',
      selectSeat: 'Select Seat',
      chooseSeat: '-- Choose a seat --',
      selectedSeat: 'Selected Seat',
      date: 'Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      timeSlot: 'Time Slot',
      chooseTimeSlot: '-- Choose time slot --',
      totalAmount: 'Total Amount',
      paymentMethod: 'Payment Method',
      onlinePayment: 'Online Payment',
      onlinePaymentDesc: 'Pay securely online (UPI, Card, Net Banking)',
      offlinePayment: 'Offline Payment',
      offlinePaymentDesc: 'Pay at library counter',
      yourName: 'Your Name',
      email: 'Email',
      notes: 'Notes',
      notesPlaceholder: 'Any special requests...',
      proceedPayment: 'Proceed to Payment',
      confirmBooking: 'Confirm Booking',
      booking: 'Booking...',
      manager: 'Manager',
      position: 'Position',
      pnbManager: 'PNB Bank Branch Manager',
      phone: 'Phone',
      usefulLinks: 'Useful Links',
      libraryTiming: 'Library Timing',
      dailyHours: 'Daily Hours',
      openAllDays: 'Open all 7 days a week',
      closedHolidays: 'Closed on Gazetted Holidays',
      cctvNotice: 'You Are Under CCTV Surveillance In Library',
      copyright: 'Dhaka Library, Nohar. All rights reserved.'
    },
    hi: {
      libraryName: 'ढाका पुस्तकालय',
      subtitle: 'नोहर, राजस्थान में अपना सही अध्ययन स्थान बुक करें',
      home: 'होम',
      aboutUs: 'हमारे बारे में',
      aboutLibrary: 'पुस्तकालय के बारे में',
      missionVision: 'मिशन और विज़न',
      libraryStaff: 'पुस्तकालय स्टाफ',
      services: 'सेवाएं',
      bookLending: 'पुस्तक उधार',
      readingRoom: 'वाचनालय',
      digitalServices: 'डिजिटल सेवाएं',
      photoGallery: 'फोटो गैलरी',
      eResources: 'ई-संसाधन',
      sscExam: 'SSC परीक्षा पिछले प्रश्न पत्र',
      rpscTeacher: 'RPSC शिक्षक परीक्षा',
      digitalLibrary: 'डिजिटल पुस्तकालय',
      eBooks: 'ई-पुस्तकें',
      researchSupport: 'अनुसंधान सहायता',
      researchGuides: 'अनुसंधान गाइड',
      thesisRepository: 'थीसिस संग्रह',
      citationHelp: 'उद्धरण सहायता',
      loading: 'उपलब्ध सीटें लोड हो रही हैं...',
      tryAgain: 'पुनः प्रयास करें',
      studySeats: 'अध्ययन सीटें',
      allSeats: 'सभी सीटें',
      available: 'उपलब्ध',
      occupied: 'आरक्षित',
      noSeats: 'चयनित फ़िल्टर से कोई सीट मेल नहीं खाती।',
      type: 'प्रकार',
      floor: 'मंजिल',
      amenities: 'सुविधाएं',
      bookNow: 'अभी बुक करें',
      bookSeat: 'सीट बुक करें',
      timeSlotsPrice: 'समय स्लॉट और मूल्य',
      morningShift: 'प्रातः पाली',
      eveningShift: 'संध्या पाली',
      fullDay: 'पूरा दिन',
      save: 'बचत',
      selectSeat: 'सीट चुनें',
      chooseSeat: '-- एक सीट चुनें --',
      selectedSeat: 'चयनित सीट',
      date: 'तारीख',
      startDate: 'प्रारंभ तिथि',
      endDate: 'समाप्ति तिथि',
      timeSlot: 'समय स्लॉट',
      chooseTimeSlot: '-- समय स्लॉट चुनें --',
      totalAmount: 'कुल राशि',
      paymentMethod: 'भुगतान विधि',
      onlinePayment: 'ऑनलाइन भुगतान',
      onlinePaymentDesc: 'सुरक्षित ऑनलाइन भुगतान करें (UPI, कार्ड, नेट बैंकिंग)',
      offlinePayment: 'ऑफ़लाइन भुगतान',
      offlinePaymentDesc: 'पुस्तकालय काउंटर पर भुगतान करें',
      yourName: 'आपका नाम',
      email: 'ईमेल',
      notes: 'नोट्स',
      notesPlaceholder: 'कोई विशेष अनुरोध...',
      proceedPayment: 'भुगतान के लिए आगे बढ़ें',
      confirmBooking: 'बुकिंग की पुष्टि करें',
      booking: 'बुकिंग हो रही है...',
      manager: 'प्रबंधक',
      position: 'पद',
      pnbManager: 'PNB बैंक शाखा प्रबंधक',
      phone: 'फोन',
      usefulLinks: 'उपयोगी लिंक',
      libraryTiming: 'पुस्तकालय समय',
      dailyHours: 'दैनिक घंटे',
      openAllDays: 'सप्ताह के सभी 7 दिन खुला',
      closedHolidays: 'राजपत्रित अवकाशों पर बंद',
      cctvNotice: 'आप पुस्तकालय में CCTV निगरानी के अंतर्गत हैं',
      copyright: 'ढाका पुस्तकालय, नोहर। सर्वाधिकार सुरक्षित।'
    }
  }

  const t = translations[language]

  useEffect(() => {
    fetchSeats()
  }, [])

  const fetchSeats = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/seats?withBookingStatus=true`)
      if (!response.ok) {
        throw new Error('Failed to fetch seats')
      }
      const data = await response.json()
      setSeats(data.data || [])
      setError(null)
    } catch (err) {
      setError(err.message)
      console.error('Error fetching seats:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleSeatClick = (seat) => {
    setSelectedSeat(seat)
    // Scroll to booking section
    setTimeout(() => {
      document.querySelector('.booking-section')?.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }

  // Filter seats based on availability
  const filteredSeats = availabilityFilter === null 
    ? seats 
    : availabilityFilter === 'available'
      ? seats.filter(seat => !seat.has_active_bookings)
      : seats.filter(seat => seat.has_active_bookings)

  return (
    <div className="app">
      <header className="header">
        <div className="header-top">
          <div className="header-logo">
            <div className="logo-circle">📚</div>
            <div className="header-titles">
              <h1 className="hindi-title">ढाका पुस्तकालय</h1>
              <h2 className="english-title">{t.libraryName}</h2>
            </div>
          </div>
          <div className="header-right">
            <div className="language-selector">
              <select 
                id="language" 
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="en">English</option>
                <option value="hi">हिंदी</option>
              </select>
            </div>
            <div className="social-icons">
              <a href="#" aria-label="Facebook">📘</a>
              <a href="#" aria-label="Twitter">🐦</a>
              <a href="#" aria-label="Instagram">📷</a>
            </div>
          </div>
        </div>
        
        <nav className="navbar">
          <ul className="nav-menu">
            <li><a onClick={() => setActiveSection('home')} style={{cursor: 'pointer'}} className={activeSection === 'home' ? 'active' : ''}>🏠 {t.home}</a></li>
            <li className="dropdown">
              <a onClick={() => setActiveSection('about')} style={{cursor: 'pointer'}} className={activeSection === 'about' || activeSection === 'mission' || activeSection === 'staff' ? 'active' : ''}>{t.aboutUs} ▼</a>
              <ul className="dropdown-menu">
                <li><a onClick={() => setActiveSection('about')} style={{cursor: 'pointer'}}>{t.aboutLibrary}</a></li>
                <li><a onClick={() => setActiveSection('mission')} style={{cursor: 'pointer'}}>{t.missionVision}</a></li>
                <li><a onClick={() => setActiveSection('staff')} style={{cursor: 'pointer'}}>{t.libraryStaff}</a></li>
              </ul>
            </li>
            <li className="dropdown">
              <a onClick={() => setActiveSection('services')} style={{cursor: 'pointer'}} className={activeSection === 'services' || activeSection === 'book-lending' || activeSection === 'reading-room' ? 'active' : ''}>{t.services} ▼</a>
              <ul className="dropdown-menu">
                <li><a onClick={() => setActiveSection('book-lending')} style={{cursor: 'pointer'}}>{t.bookLending}</a></li>
                <li><a onClick={() => setActiveSection('reading-room')} style={{cursor: 'pointer'}}>{t.readingRoom}</a></li>
                <li><a onClick={() => setActiveSection('services')} style={{cursor: 'pointer'}}>{t.digitalServices}</a></li>
              </ul>
            </li>
            <li><a onClick={() => setActiveSection('photo-gallery')} style={{cursor: 'pointer'}} className={activeSection === 'photo-gallery' ? 'active' : ''}>📸 {t.photoGallery}</a></li>
            <li className="dropdown">
              <a href="#e-resources">{t.eResources} ▼</a>
              <ul className="dropdown-menu">
                <li><a href="https://ssc.nic.in/" target="_blank" rel="noopener noreferrer">{t.sscExam}</a></li>
                <li><a href="https://rpsc.rajasthan.gov.in/" target="_blank" rel="noopener noreferrer">{t.rpscTeacher}</a></li>
                <li><a href="#digital-library">{t.digitalLibrary}</a></li>
                <li><a href="#e-books">{t.eBooks}</a></li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="#research-support">{t.researchSupport} ▼</a>
              <ul className="dropdown-menu">
                <li><a href="#research-guides">{t.researchGuides}</a></li>
                <li><a href="#thesis-repository">{t.thesisRepository}</a></li>
                <li><a href="#citation-help">{t.citationHelp}</a></li>
              </ul>
            </li>
          </ul>
        </nav>
        
        <div className="header-subtitle">
          <p>{t.subtitle}</p>
        </div>
      </header>

      <main className="main-content">
        {/* About Library Section - Top of the page */}
        {activeSection === 'about' && (
        <section className="about-section" id="about">
          <div className="about-container">
            <div className="about-text">
              <h2>🏛️ {language === 'hi' ? 'पुस्तकालय के बारे में' : 'About Library'}</h2>
              <p className="about-description">
                {language === 'hi' 
                  ? 'ढाका लाइब्रेरी नोहर, नोहर क्षेत्र में सबसे अग्रणी पुस्तकालयों में से एक है जो न्यूनतम कीमतों पर अच्छी सुविधाएं प्रदान करता है। हम पूर्ण गति के साथ WiFi, आपकी बैठने के लिए लचीला समय, AC, आरामदायक कुर्सियां और बहुत कुछ प्रदान करते हैं।'
                  : 'Dhaka Library Nohar is one of the most Leading Library in Nohar area with good facilities at minimum prices. We provide WiFi with full speed, Flexible timing for your seating, AC, Comfortable chairs and so on.'
                }
              </p>
              <div className="special-feature">
                <span className="feature-badge">🏢 {language === 'hi' ? 'छत उपलब्ध' : 'Terrace Available'}</span>
                <span className="feature-badge">🌟 {language === 'hi' ? 'सर्वश्रेष्ठ सुविधाएं' : 'Best Facilities'}</span>
                <span className="feature-badge">💰 {language === 'hi' ? 'न्यूनतम मूल्य' : 'Minimum Prices'}</span>
              </div>
            </div>
          </div>
        </section>
        )}

        {/* Loading and Error states - Temporarily Disabled */}
        {/* {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>{t.loading}</p>
          </div>
        )}

        {error && (
          <div className="error">
            <p>⚠️ {error}</p>
            <button onClick={fetchSeats}>{t.tryAgain}</button>
          </div>
        )} */}

        {/* Photo Gallery Section */}
        {activeSection === 'photo-gallery' && (
            <section className="photo-gallery-section" id="photo-gallery">
              <h2>📸 {language === 'hi' ? 'फोटो गैलरी' : 'Photo Gallery'}</h2>
              <p className="gallery-subtitle">{language === 'hi' ? 'हमारी आधुनिक सुविधाओं की झलक' : 'A Glimpse of Our Modern Facilities'}</p>
              <div className="photo-gallery">
                <div className="gallery-item">
                  <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=800" alt="Library Study Desks" />
                  <div className="gallery-caption">{language === 'hi' ? 'अध्ययन डेस्क और लॉकर' : 'Study Desks with Lockers'}</div>
                </div>
                <div className="gallery-item">
                  <img src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=800" alt="Library Reading Hall" />
                  <div className="gallery-caption">{language === 'hi' ? 'विशाल वाचनालय' : 'Spacious Reading Hall'}</div>
                </div>
                <div className="gallery-item">
                  <img src="https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=800" alt="Library Building" />
                  <div className="gallery-caption">{language === 'hi' ? 'पुस्तकालय भवन' : 'Library Building'}</div>
                </div>
              </div>
              <p className="gallery-note">📍 {language === 'hi' ? 'नोहर में स्व-अध्ययन के लिए एक आदर्श स्थान' : 'A Perfect Place for Self Learning in Nohar'}</p>
            </section>
            )}

            {activeSection === 'home' && (
            <>
            {/* Services Overview on Home */}
            <section className="home-services">
              <h2>🌟 {language === 'hi' ? 'हमारी सेवाएं' : 'Our Services'}</h2>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon">📶</div>
                  <h3>{language === 'hi' ? 'हाई-स्पीड WiFi' : 'High-Speed WiFi'}</h3>
                  <p>{language === 'hi' ? 'पूर्ण गति इंटरनेट' : 'Full speed internet'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">❄️</div>
                  <h3>{language === 'hi' ? 'AC सुविधा' : 'Air Conditioned'}</h3>
                  <p>{language === 'hi' ? 'आरामदायक तापमान' : 'Comfortable temperature'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">🪑</div>
                  <h3>{language === 'hi' ? 'आरामदायक कुर्सियां' : 'Comfortable Chairs'}</h3>
                  <p>{language === 'hi' ? 'एर्गोनोमिक डिज़ाइन' : 'Ergonomic seating'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">🏢</div>
                  <h3>{language === 'hi' ? 'छत उपलब्ध' : 'Terrace Available'}</h3>
                  <p>{language === 'hi' ? 'खुली हवा में अध्ययन' : 'Open air study area'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">⏰</div>
                  <h3>{language === 'hi' ? 'लचीला समय' : 'Flexible Timing'}</h3>
                  <p>{language === 'hi' ? '06:00 AM - 08:00 PM' : '06:00 AM - 08:00 PM'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">🔒</div>
                  <h3>{language === 'hi' ? 'सुरक्षित लॉकर' : 'Secure Lockers'}</h3>
                  <p>{language === 'hi' ? 'व्यक्तिगत भंडारण' : 'Personal storage'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">💡</div>
                  <h3>{language === 'hi' ? 'उचित रोशनी' : 'Proper Lighting'}</h3>
                  <p>{language === 'hi' ? 'आंखों के अनुकूल' : 'Eye-friendly lighting'}</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">🔇</div>
                  <h3>{language === 'hi' ? 'शांत वातावरण' : 'Quiet Environment'}</h3>
                  <p>{language === 'hi' ? 'अध्ययन के लिए आदर्श' : 'Perfect for studying'}</p>
                </div>
                <div className="service-card" style={{ background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', border: '2px solid #f59e0b' }}>
                  <div className="service-icon">🎥</div>
                  <h3>{language === 'hi' ? 'CCTV निगरानी' : 'CCTV Surveillance'}</h3>
                  <p>{language === 'hi' ? 'आपकी सुरक्षा के लिए' : 'For your security'}</p>
                </div>
              </div>
            </section>

            {/* Seat Booking Section - Temporarily Disabled */}
            </>
            )}

            {/* <section className="seats-section">
              <div className="section-header">
                <h2>{t.studySeats}</h2>
                <div className="availability-tabs" style={{ marginTop: '15px' }}>
                  <button 
                    className={`tab-btn ${!availabilityFilter ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter(null)}
                  >
                    {t.allSeats} ({seats.length})
                  </button>
                  <button 
                    className={`tab-btn available ${availabilityFilter === 'available' ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter('available')}
                  >
                    ✓ {t.available} ({seats.filter(s => !s.has_active_bookings).length})
                  </button>
                  <button 
                    className={`tab-btn unavailable ${availabilityFilter === 'unavailable' ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter('unavailable')}
                  >
                    ✗ {t.occupied} ({seats.filter(s => s.has_active_bookings).length})
                  </button>
                </div>
              </div>

              {filteredSeats.length === 0 ? (
                <p className="no-seats">{t.noSeats}</p>
              ) : (
                <div className="seats-grid">
                  {filteredSeats.map((seat) => (
                    <div 
                      key={seat.id} 
                      className={`seat-card ${!seat.has_active_bookings ? 'available' : 'unavailable'}`}
                      onClick={() => !seat.has_active_bookings && handleSeatClick(seat)}
                      style={{ cursor: !seat.has_active_bookings ? 'pointer' : 'not-allowed' }}
                    >
                      <div className="seat-header">
                        <span className="seat-number">{seat.seat_number}</span>
                        <span className={`seat-status ${!seat.has_active_bookings ? 'available' : 'unavailable'}`}>
                          {!seat.has_active_bookings ? `✓ ${t.available}` : `✗ ${t.occupied}`}
                        </span>
                      </div>
                      <div className="seat-details">
                        <p><strong>{t.type}:</strong> {seat.seat_type}</p>
                        <p><strong>{t.floor}:</strong> {seat.floor}</p>
                        {seat.amenities && seat.amenities.length > 0 && (
                          <div className="amenities">
                            <strong>{t.amenities}:</strong>
                            <ul>
                              {seat.amenities.map((amenity, index) => (
                                <li key={index}>{amenity.replace('_', ' ')}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {!seat.has_active_bookings && (
                          <button className="book-now-btn">
                            {t.bookNow} →
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </section>

            {selectedSeat && (
              <section className="booking-section">
                <div className="booking-header">
                  <h2>{t.bookSeat} {selectedSeat.seat_number}</h2>
                  <button className="close-btn" onClick={() => setSelectedSeat(null)}>✕</button>
                </div>
                
                <div className="pricing-info">
                  <h3>📅 {t.timeSlotsPrice}</h3>
                  <div className="time-slots">
                    <div className="time-slot-card">
                      <div className="slot-icon">🌅</div>
                      <div className="slot-details">
                        <h4>{t.morningShift}</h4>
                        <p className="slot-time">06:00 AM - 01:00 PM</p>
                        <p className="slot-price">₹600</p>
                      </div>
                    </div>
                    <div className="time-slot-card">
                      <div className="slot-icon">🌆</div>
                      <div className="slot-details">
                        <h4>{t.eveningShift}</h4>
                        <p className="slot-time">01:00 PM - 08:00 PM</p>
                        <p className="slot-price">₹600</p>
                      </div>
                    </div>
                    <div className="time-slot-card full-day">
                      <div className="slot-icon">🌞</div>
                      <div className="slot-details">
                        <h4>{t.fullDay}</h4>
                        <p className="slot-time">06:00 AM - 08:00 PM</p>
                        <p className="slot-price">₹1000</p>
                        <span className="savings-badge">{t.save} ₹200!</span>
                      </div>
                    </div>
                  </div>
                </div>

                <BookingWidget 
                  seats={seats} 
                  apiUrl={API_URL} 
                  onBookingComplete={fetchSeats}
                  selectedSeat={selectedSeat}
                  translations={t}
                />
              </section>
            )}
            */}
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>📚 {t.libraryName}</h3>
            </div>
            <p className="footer-contact"><strong>{t.manager}:</strong> Mr. PR Dhaka</p>
            <p className="footer-contact"><strong>{t.position}:</strong> {t.pnbManager}</p>
            <p className="footer-contact"><strong>{t.phone}:</strong> +91 70141 41521</p>
            <p className="footer-address">
              Dhaka Library, Bus Stand, Nohar - Sardarshahar Rd,<br />
              opposite Shubham Hospital, near Sahawa,<br />
              Nohar, Rajasthan 335523, India
            </p>
          </div>

          <div className="footer-section">
            <h4>{t.usefulLinks}</h4>
            <ul className="footer-links">
              <li><a href="https://ndl.iitkgp.ac.in/" target="_blank" rel="noopener noreferrer">🔗 National Digital Library of India</a></li>
              <li><a href="https://www.inflibnet.ac.in/" target="_blank" rel="noopener noreferrer">🔗 INFLIBNET Centre</a></li>
              <li><a href="https://www.nptel.ac.in/" target="_blank" rel="noopener noreferrer">🔗 NPTEL Online Courses</a></li>
              <li><a href="https://swayam.gov.in/" target="_blank" rel="noopener noreferrer">🔗 SWAYAM (Study Webs of Active Learning)</a></li>
              <li><a href="https://epgp.inflibnet.ac.in/" target="_blank" rel="noopener noreferrer">🔗 eGyanKosh (IGNOU Digital Repository)</a></li>
              <li><a href="https://www.ugc.ac.in/" target="_blank" rel="noopener noreferrer">🔗 University Grants Commission (UGC)</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t.libraryTiming}</h4>
            <div className="timing-info">
              <p><strong>⏰ {t.dailyHours}:</strong></p>
              <p className="timing-hours">06:00 AM to 08:00 PM</p>
              <p className="timing-days">({language === 'hi' ? 'सोमवार से रविवार' : 'Monday to Sunday'})</p>
              <div className="timing-note">
                <p>ℹ️ <em>{t.openAllDays}</em></p>
                <p>📅 {t.closedHolidays}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2024 {t.copyright}</p>
        </div>
      </footer>
    </div>
  )
}

export default App
